// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"a348fed5","67":"7d6fab8d","80":"7d6fab8d","214":"daaad9c4","381":"c9be751d","771":"7d6fab8d","856":"97c6caff"}[chunkId] + ".chunk.css";
};